<template>
  <div class="pc-main">
    <div class="pc-main-inner">
      <img src="./images/1.jpg" />

      <div class="pc-main-inner__text">
        <p class="title">湖南雷锋纪念馆简介</p>
        <div class="scroll" style="max-height: 55vh; overflow: auto">
          <p>
            湖南雷锋纪念馆位于湖南省长沙市望城区雷锋街道正兴路42号，馆区总占地面积10.4万平方米，主要参观内容包括雷锋生平事迹陈列馆、雷锋故居、“与时代同行——纪念毛泽东等老一辈革命家为雷锋同志题词六十周年专题展”、长沙国防（人防）教育馆、长沙好人馆等。
          </p>
          <p>
            基本陈列《学习雷锋好榜样》，分为“平凡的人生”“伟大的精神”“永远的榜样”三个部分。陈展面积为3881㎡，共展出文物实物368件，照片359张，雷锋日记诗文61篇。客观真实地展示了雷锋同志平凡而伟大的一生，突出了雷锋同志的成长历程及雷锋精神在雷锋家乡的起源和传承。
          </p>
          <p>
            湖南雷锋纪念馆是研究、宣传、践行雷锋精神的主阵地，是弘扬以伟大建党精神为源头的中国共产党人精神谱系，深入开展社会主义核心价值观宣传教育，深化爱国主义、集体主义、社会主义教育的重要平台，也是开展青少年思想政治教育的重要课堂。开馆60年来，雷锋馆人以“播雷锋精神，做雷锋传人”为己任，共接待国内外游客5000多万人次，近年年均接待游客量突破200万人次。纪念馆先后获评全国爱国主义教育示范基地、国家AAAA级旅游景区、全国文明单位、全国学雷锋活动示范点、国家国防教育示范基地、全国青少年教育基地、全国关心下一代党史国史教育基地、全国红色旅游经典景区、全国三八红旗集体、全国最佳志愿服务组织等荣誉称号。
          </p>
        </div>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.pc-main {
  position: absolute;
  top: 17vh;
  left: 50%;
  transform: translateX(-50%);

  :deep(.button) {
    position: absolute;
    right: 0;
    bottom: calc(-76px + -5vh);
  }
  .scroll {
    &::-webkit-scrollbar {
      width: 4px;
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #bd6464;
    }
    p {
      text-indent: 2em;
      line-height: 32px;
    }
  }
  &-inner {
    display: flex;
    align-items: flex-start;

    img {
      flex-shrink: 0;
      margin-right: 50px;
      width: 53.6vw;
      object-fit: contain;
    }
    &__text {
      flex-shrink: 0;
      width: 440px;
      color: #333333;
      font-size: 16px;

      .title {
        margin-bottom: 20px;
        font-size: 30px;
        font-weight: bold;
        color: #b90c0c;
      }
    }
  }
}
</style>
